import type {ReactNode} from 'react'
import {useTranslation} from 'react-i18next'

import {TableRow, TableCell} from './Table.styled'
import {Icon} from '../icon/Icon'

import {Typography} from '~/components/general/typography/Typography'
import {theme} from '~/styles/theme'
import {manualRecordIconName} from '~/icons'

export type SimpleTableRowProps = {
  columns: Array<string | ReactNode>
  rowKey?: string
  hasParsedData?: boolean
  onRowClick?: () => void
  actionComponent?: ReactNode
  // Optional: to apply text decoration to specific cells. Use the cell index as the key.
  cellTextDecoration?: Record<number, 'none' | 'underline' | 'line-through'>
}

export const SimpleTableRow = ({
  columns,
  hasParsedData,
  onRowClick,
  actionComponent,
  cellTextDecoration = {},
}: SimpleTableRowProps) => {
  const {t} = useTranslation<string>()

  return (
    <TableRow onClick={onRowClick}>
      {columns.map((cell, index) => (
        <TableCell
          title={typeof cell === 'string' ? cell : undefined}
          key={`${index}-${typeof cell === 'string' ? cell : 'node'}`}>
          {typeof cell === 'string' ? (
            <Typography
              ellipsis
              color={theme.colors.grey.grey600}
              textDecoration={cellTextDecoration[index] || undefined}
              weight="normal">
              {cell}
            </Typography>
          ) : (
            cell
          )}
        </TableCell>
      ))}
      {hasParsedData != null && (
        <TableCell
          title={hasParsedData ? t('Parsed from pdf') : t('Manually added')}>
          <Icon name={hasParsedData ? 'Pdf' : manualRecordIconName} />
        </TableCell>
      )}
      {actionComponent && (
        <TableCell
          onClick={(e) => e.stopPropagation()}
          style={{width: '100px'}}>
          {actionComponent}
        </TableCell>
      )}
    </TableRow>
  )
}
